// https://github.com/stanleybz/react-float-button

/* eslint-disable */
import React, { Component } from 'react';

// Index component
export class FloatGroup extends Component {
  constructor () {
    super();
    this.state = {
      show: false,
    };
    this.showUpdate = this.showUpdate.bind(this);
  }

  static defaultProps = {
    margin: 50,
    children: [],
    style: {},
    delay: 0.03,
    direction: 'up'
  }

  showUpdate (e) {
    e.stopPropagation()
    this.setState({
      show: !this.state.show,
    });
  }

  render () {
    const {} = this.props
    const {} = this.state

    const divStyle = Object.assign({}, this.props.style, { position: 'relative' });
    return (
      <div style={divStyle}>
        {
          Object.prototype.toString.call(this.props.children) === '[object Array]' &&
          this.props.children.map((item, i) => {
            if (i === 0) {
              return (
                <div
                  key={`float-btn-${i}`}
                  tabIndex={0}
                  role="button"
                  style={{ zIndex: 900, position: 'relative', outline: 'unset' }}
                  onClick={this.showUpdate.bind(this)}
                >
                  {item}
                </div>
              );
            }

            let style = {
              zIndex:1,
              position: 'absolute',
              opacity: this.state.show ? 1 : 0,
              visibility: this.state.show ? 'visible' : 'hidden',

              MsTransition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              WebkitTransition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              transition: 'all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)',

              MsTransitionDelay: `${i * this.props.delay}s`,
              WebkitTransitionDelay: `${i * this.props.delay}s`,
              transitionDelay: `${i * this.props.delay}s`,

              MsTransform: `scale(${this.state.show ? 1 : 0}, ${this.state.show ? 1 : 0})`,
              WebkitTransform: `scale(${this.state.show ? 1 : 0}, ${this.state.show ? 1 : 0})`,
              transform: `scale(${this.state.show ? 1 : 0}, ${this.state.show ? 1 : 0})`

            }

            switch(this.props.direction) {
              case 'up':
                style.bottom = this.state.show ? this.props.margin * i : 0
                break
              case 'right':
                style.left = this.state.show ? this.props.margin * i : 0
                style.display = 'flex'
                style.bottom = '0px'
                break
              case 'left':
                style.right = this.state.show ? this.props.margin * i : 0
                style.display = 'flex'
                style.bottom = '0px'
                break
            }

            return (
              <div
                key={`float-btn-${i}`}
                tabIndex={-1}
                role="button"
                style={style}
                onClick={this.showUpdate}
              >
                {item}
              </div>
            );
          })}
      </div>
    );
  }
}
